import {
  FaceSmileIcon,
  HeartIcon,
  LifebuoyIcon,
  UserCircleIcon,
  UserIcon,
  UserPlusIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import { RelatedUserRole } from "../../api/relationship.type";

const ICON_MAP: Record<
  RelatedUserRole,
  React.ComponentType<{ className?: string }>
> = {
  parent: UsersIcon,
  child: UserCircleIcon,
  spouse: HeartIcon,
  doctor: UserPlusIcon,
  patient: LifebuoyIcon,
  friend: FaceSmileIcon,
  cousin: UsersIcon,
  other: UserIcon,
  grandparent: UsersIcon,
  grandchild: UserIcon,
  aunt: UsersIcon,
  uncle: UsersIcon,
  nephew: UserIcon,
  niece: UserIcon,
};

export function RelationshipIcon({
  role,
  className,
}: {
  role?: string | null;
  className?: string;
}) {
  if (!role) return null;
  const Icon = ICON_MAP[role as RelatedUserRole];
  if (Icon) {
    return <Icon className={className} />;
  }
  return <span className="capitalize">{role}</span>;
}
